import { render, staticRenderFns } from "./TeamInboxChat.vue?vue&type=template&id=45185cd1&scoped=true&"
import script from "./TeamInboxChat.vue?vue&type=script&lang=js&"
export * from "./TeamInboxChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45185cd1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45185cd1')) {
      api.createRecord('45185cd1', component.options)
    } else {
      api.reload('45185cd1', component.options)
    }
    module.hot.accept("./TeamInboxChat.vue?vue&type=template&id=45185cd1&scoped=true&", function () {
      api.rerender('45185cd1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TeamInbox/TeamInboxChat.vue"
export default component.exports